module.exports = __webpack_public_path__ + "static/media/night.f8f667f7.mp4";